<template >
  <div>
    <sc-field>
      Opções selecionadas: {{ selectedOptions.join(", ") }}
    </sc-field>
      <sc-multiple-selection
        :hasActions="false"
        :options="parsedOptions"
        v-model="selectedOptions"
        @input="onChange"

        >
      </sc-multiple-selection>
  </div>
</template>

<script>
import {
  ScMultipleSelection,
  ScField,
  ScDialog
} from "@intelipost-js/secure-components";
import { createNamespacedHelpers } from "vuex";
import ModalConfig from "../config/ModalConfig.vue";

const { mapState, mapActions } = createNamespacedHelpers(
  "integrations/integrationsHome"
);

export default {
  name: "iplink-list-option-field",

  data() {
    return {
      parsedOptions: [],
      selectedOptions: []
    }
  },

  props: {
    fieldSchema: {
      type: Object,
      required: true,
    }
  },

  computed: {
    ...mapState(["appConfigUpdated"]),
  },

  methods: {

    ...mapActions([
      "updateAppConfig",
      "setWindowEdit"
    ]),


    onChange() {

      const isValid = this.verifyArrayLength();

      if(isValid){
        this.updateListOptionInAppConfig();
      }
    },

    verifyArrayLength() {
      const isValid = (this.selectedOptions.length <= this.fieldSchema.list_max_length)
      if (!isValid) {
        ScDialog.alert({
          title: 'ATENÇÃO',
          message: 'Só é possível escolher até ' + this.fieldSchema.list_max_length + ' opções',
          confirmText: 'Ok',
          onConfirm: () => this.selectedOptions.pop()
        })
      }
      return isValid
    },

    updateListOptionInAppConfig() {
      const appConfig = {
        ...this.appConfigUpdated,
      }

      appConfig[this.fieldSchema.name] = [...this.selectedOptions]
      this.updateAppConfig(appConfig)
    },
  },

  components: {
    ScField,
    ScMultipleSelection,
    ModalConfig,
    ScDialog
  },

  mounted() {
    this.parsedOptions = this.fieldSchema.options.map((option) => ({
      value: option,
      label: option
    }))

    const initialValue = this.appConfigUpdated[this.fieldSchema.name];
    if (Array.isArray(initialValue)) {
      this.selectedOptions = [...initialValue];
    }
  },
}
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";



.sc-multiple-selection__filters-dropdown {

  display: block;
  width: 35%;

}

.control.has-icons-left .input {
  padding-left: 7px;
}

.fas.fa-filter {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/modal/components/ListOptionField.vue?4dfd6177